import React from "react";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import TickIcon from "assets/img/svg/svgComponents/TickIcon";
import moment from "moment";

const SuccessAlert = ({ approverName,approverId, closeHandler }) => {
  const sendTo = ` to ${approverId} - ${approverName}`
  return (
    <div className="approval-sent-dialog p-2" style={{width:"400x"}}>
      <span className="d-flex justify-content-center align-items-center tick-icon">
        <TickIcon />
      </span>
      <div className="header">
        Request  has been sent for approval {sendTo}
      </div>
      <div className="label-text label-color">
        {moment().format("DD-MMM-YYYY hh:mm A")}
      </div>
      <AButton
        variant="primary_filled"
        onClick={() => closeHandler(false)}
        className="no-ml-btn w-25"
      >
        Okay
      </AButton>
    </div>
  );
};

export default SuccessAlert;
